/*
 * @Description: 获取慧教云网关toekn
 * @Author: luozhao
 * @Date: 2021-04-07 09:34:42
 */

import axios from 'axios';
import BetterStorage from './betterStorage.service.js';
import { PLATFORM_OPEN_API, PLATFORM_OPEN_APP_ID } from '../config/app.config.js';
// import { getTicket } from './ticket.service.js';
import { getTicket } from "@/api/user/userCenter.js";
import { getUsessionId } from './usession.service.js';
const betterStorage = new BetterStorage();

/**
 * @description: 获取天喻云统一网关访问 userToken
 * @author luozhao
 * @export
 * @param {String} ticket
 * @param {String} loginPlatformCode: 实体平台码
 * @returns
 */
export async function getToken() {
    let userToken = betterStorage.get('userToken');
    if (!userToken) {
        const platformCode = sessionStorage.getItem('platformCode');
        const uid = sessionStorage.getItem('usessionid');
       let ticket = await getTicket(uid);
        // console.log('通过usessionid获取新的ticket*********************:', ticket);
        const { data: { retCode, tokenInfo } = {} } = await axios({
            url: `${PLATFORM_OPEN_API}/apigateway/getUserToken`,
            method: 'post',
            data: {
                ticket,
                platformCode: sessionStorage.getItem('authPlatformCode') || platformCode
            },
            headers: {
                'Ty-Appid': PLATFORM_OPEN_APP_ID,
                'Ty-Timestamp': new Date().getTime()
            }
        });
        if (retCode === '000000') {
            console.log('获取userToken--', tokenInfo.userToken);
            betterStorage.set('userToken', tokenInfo.userToken, 90 * 60 * 1000);
            userToken = tokenInfo.userToken;
        }
    }
    return userToken;
}

